// extracted by mini-css-extract-plugin
export default {"button":"ButtonUp_button__ow+LS","visible":"ButtonUp_visible__lvtEP","icon":"ButtonUp_icon__mWCa7"};